import { useLayoutEffect, useRef } from 'react';

export function useLockScroll(locked: any) {
	const scrollYRef = useRef(0);

	useLayoutEffect(() => {
		if (!locked) return;

		scrollYRef.current = window.scrollY || window.pageYOffset || 0;

		const { style } = document.body;
		const prev = {
			position: style.position,
			top: style.top,
			width: style.width,
			overflowY: style.overflowY,
			overscrollBehavior: style.overscrollBehavior,
		};

		style.position = 'fixed';
		style.top = `-${scrollYRef.current}px`;
		style.width = '100%';
		style.overflowY = 'scroll';
		style.overscrollBehavior = 'none';

		return () => {
			style.position = prev.position;
			style.top = prev.top;
			style.width = prev.width;
			style.overflowY = prev.overflowY;
			style.overscrollBehavior = prev.overscrollBehavior;
			window.scrollTo(0, scrollYRef.current);
		};
	}, [locked]);
}
